


































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { getQueryVariable } from "@/services/api"

interface paneitem {
  label: string;
  value: string;
  count:number;
}
const GreetingProps = Vue.extend({
  props: {
    tableData: Array,
    pageInfo: Object,
    flowDetailObj:Object,
    showTabs:String,
    totalClickCount:Number,
    totalUniqueClickCount:Number
  }
})
@Component({})
export default class wheelOfFortuneList extends GreetingProps {
  paneList: paneitem[]= []

  paneActiveName :string = getQueryVariable('activeTab') ? 'Orders' : 'Wait'

  emails :string = '';
  phones: string = '';

  flowDetail: any = {
    daterange:''
  };
  // showTabs:string =  'SendDetailed'

  handShowTabs(val:string){
    this.$emit('handShowTabs',val)
  }

  handleEmailGo(item) {
    const flowId = location?.pathname?.split('/')[4]
    window.location.href = process.env.VUE_APP_DOMAIN + `/cartsee-new/userDetail?email=${item}&flowId=${flowId}&strategyChannel=${getQueryVariable('strategyChannel')}&cname=${getQueryVariable('cname')}&id=${getQueryVariable('id')}&type=flow&menu=false&navbar=false`
  }

  created(): void {
    this.paneList = this.$route.query.strategyChannel === 'Sms'? [
      {label:'等待',value:'Wait' ,count:0},
      {label:'发送',value:'Send',count:0},
      {label:'送达',value:'Delivery',count:0},
      {label:'过滤',value:'Filter',count:0},
      {label:'点击',value:'Click',count:0},
      {label:'下单',value:'Orders',count:0},
      {label:'退回',value:'Bounce',count:0},
      {label:'退订',value:'Unsubscribe',count:0},
    ]:[
      {label:'等待',value:'Wait' ,count:0},
      {label:'发送',value:'Send',count:0},
      {label:'过滤',value:'Filter',count:0},
      {label:'打开',value:'Open',count:0},
      {label:'点击',value:'Click',count:0},
      {label:'下单',value:'Orders',count:0},
      {label:'退回',value:'Bounce',count:0},
      {label:'退订',value:'Unsubscribe',count:0},
      {label:'投诉',value:'Complaint',count:0},
    ]
    // this.getWheelOfFortuneList();
  }
  mounted() {
    this.handleClick({ name: 'Wait'})
  }
  clickURL(val:string){
    window.open(val)
  }
  //
  getColumn( val?:string, isShow?:boolean,val2?:string){
    if (val || val2) {
      if (val === this.paneActiveName ||val2 === this.paneActiveName) {
        return isShow
      }else{
        return !isShow
      }
    }else{
      if (this.paneActiveName === 'Wait' || this.paneActiveName === 'Filter' || this.paneActiveName === 'Bounce') {
        return false
      }
    }
    return true
  }

  handleClick(vm:any,event:string){
    this.$refs.multipleTable?.clearSort()
    this.emails = '';
    this.phones = '';
    this.$emit('handleClick',vm.name)
  }

  getclass(scope:any){return '__status--' + { 0:'suspend',1 :'running'}[scope.row.status as 1 | 0]}
  gettaskStatus(scope:any) {return {
    WaitSend: "待发送",
    Delivered: "已发送",
    Bounce: "退回",
    ConditionFilter:"条件过滤",
    BlackListFilter:"黑名单过滤",
    IntelligentSendFilter: '智能过滤',
    DisableFilter: '沉默用户过滤'
    }[scope as 'WaitSend'|"Delivered"|'Bounce'|"ConditionFilter"|"BlackListFilter"| 'IntelligentSendFilter' | 'DisableFilter']}

  //显示空值
  formatterChangeNUll(r:any, c:any, v:any){return  v === 0?'$0':(`$${v}` || '-')}

  formatterChange(r:any, c:any, v:any) {return v === 0?0:(v || '-')}

  sortChange(data:any){
    this.$emit('sortChange',data)
  }

  goOrderUrl(e:string){
    window.open(e)
  }

  changeEmail(e:string){
    this.$emit('changeEmail',e)
  }

  changePhone(e:string){
    this.$emit('changePhone',e)
  }

  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.$emit('handleSizeChange',val)
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.$emit('handleCurrentChange', val)
  }
  @Watch("flowDetailObj")
  changFlowDetailObj(oldval: any, newval: any){
    let n = this.$props.flowDetailObj
    this.paneList = this.$route.query.strategyChannel === 'Sms'? [
      {label:'等待',value:'Wait' ,count:n.waitCount},
      {label:'发送',value:'Send',count: n.sendCount},
      {label:'送达',value:'Delivery',count:n.deliveryCount},
      {label:'过滤',value:'Filter',count:n.filterCount},
      {label:'点击',value:'Click',count: n.clickCount},
      {label:'下单',value:'Orders',count: n.orderDetailCount},
      {label:'退回',value:'Bounce',count:n.bounceCount},
      {label:'退订',value:'Unsubscribe',count:n.unsubscribeCount},
    ]: [
      {label:'等待',value:'Wait' ,count: n.waitCount},
      {label:'发送',value:'Send',count: n.sendCount},
      {label:'过滤',value:'Filter',count: n.filterCount},
      {label:'打开',value:'Open',count: n.openCount},
      {label:'点击',value:'Click',count: n.clickCount},
      {label:'下单',value:'Orders',count: n.orderDetailCount},
      {label:'退回',value:'Bounce',count:n.bounceCount},
      {label:'退订',value:'Unsubscribe',count:n.unsubscribeCount},
      {label:'投诉',value:'Complaint',count:n.complaintCount},
    ]
  }
}
